//antd
import Flex from 'antd/lib/flex'

//content
import HowItWorks from './HowItWorks'
import Services from './Services'
import Testimonials from './Testimonials'
import FAQ from './FAQ'
import ContactForm from './ContactForm'

const Content = () => {
    return <Flex vertical className='container'>

        <HowItWorks/>
        <Services/>
        <Testimonials/>
        <FAQ/>
        <ContactForm/>

    </Flex>
}

export default Content